/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

angular.module('zeppelinWebApp').directive('ngEnter', NgEnterDirective);

function NgEnterDirective() {
  return function(scope, element, attrs) {
    element.bind('keydown keypress', function(event) {
      if (event.which === 13) {
        if (!event.shiftKey) {
          scope.$apply(function() {
            scope.$eval(attrs.ngEnter);
          });
        }
        event.preventDefault();
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/ng-enter/ng-enter.directive.js